import React, {FunctionComponent, ReactNode} from "react";
import {Box, useMediaQuery, useTheme} from "@material-ui/core";
import {withTheme} from "@material-ui/styles";
import Text from "../../commonComponents/Text";
import backIcon from "../../images/Icons/back_icn.svg";
import SvgButton from "../../commonComponents/SvgButton";
import NextButton from "../../commonComponents/NextButton";
import {I18n} from "aws-amplify";

interface WizardStepProps {
    title: string;
    description?: string;
    icon: string;
    theme: any;
    backButton?: boolean;
    onBackClick?: () => void;
    nextButton?: boolean;
    nextButtonText?: string;
    onNextClick?: () => void;
    nextButtonDisabled?: boolean;
    children: ReactNode;
}

const WizardStep: FunctionComponent<WizardStepProps> = (props) => {

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("xs"));

    const handleBackClicked = (): void => props.onBackClick && props.onBackClick();
    const handelNextClicked = (): void => props.onNextClick && props.onNextClick();

    return (
        <Box display="flex" flexDirection="column" flex={1} alignItems="center" justifyContent={"space-between"} minHeight={isXs ? "80vh" : "70vh"}>

            <Box
                display="flex" flexDirection="column"
                alignItems="center" justifyContent="space-between"
            >
                <img src={props.icon} alt={"progress"} style={{minHeight: 86, minWidth: 86}}/>
                <Box paddingTop={3} paddingBottom={2}>
                    <Text value={props.title} size={16} width={isXs ? 310 : 650} centered/>
                </Box>
                <Box>
                    {props.description && <Text value={props.description} size={12} centered/>}
                </Box>
            </Box>

            <Box
                display="flex" flexDirection="column"
                alignItems="center"
                justifyContent="center"
            >
                {props.children}
            </Box>

            <Box
                display="flex"
                alignItems="center"
                width={isXs ? "90%" : "100%"}
                maxWidth={600}
                padding={"16px 0"}
            >
                <Box
                    position={"absolute"}
                    display={"block"}
                >
                    {props.backButton && <SvgButton svg={backIcon} onClick={handleBackClicked}/>}
                </Box>
                <Box
                    flex={2}
                    className={"nextButtonContainer"}
                    textAlign={"center"}
                >
                    {props.nextButton &&
                    <NextButton
                        text={props.nextButtonText ? props.nextButtonText : I18n.get("common").next}
                        disabled={props.nextButtonDisabled}
                        onClick={handelNextClicked}
                    />}
                </Box>
            </Box>
        </Box>
    );
};

export default withTheme(WizardStep);
